module.exports = __webpack_public_path__ + "images/66cfec6ff592019582d659995f3a03e2-students1.jpg";